<template>
  <div class="my-reports-page">
    <div class="dashboard-sticky-area">
      <div class="dashboard-topbar">
        <h4 class="dashboard-page-title">
          <CIcon name="cil-description" class="dashboard-title-icon" />
          <span>{{ isThai ? 'ประวัติแจ้งซ่อมนักศึกษา' : 'Student Repair History' }}</span>
        </h4>
      </div>
    </div>

    <CCard class="details-card mb-4">
      <CCardBody>
        <div class="table-responsive-wrapper">
          <Uhistorytable
            ref="historyTable"
            history-source="student_affairs"
            @show-detail="handleShowDetail"
          />
        </div>
      </CCardBody>
    </CCard>

    <TicketDetailModal v-if="selectedReport" @close="closeDetail">
      <UReportDetail
        :report="selectedReport"
        @close="closeDetail"
        @refresh="refreshTables"
      />
    </TicketDetailModal>
  </div>
</template>

<script>
import Uhistorytable from '@/components/user/Uhistorytable.vue';
import UReportDetail from '@/pages/user/UReportDetail.vue';
import TicketDetailModal from '@/components/common/TicketDetailModal.vue';

export default {
  name: 'StudentAffairsMyReports',
  components: {
    Uhistorytable,
    UReportDetail,
    TicketDetailModal,
  },
  data() {
    return {
      selectedReport: null,
    };
  },
  computed: {
    isThai() {
      return (this.$store?.state?.locale?.lang || 'th') === 'th';
    },
  },
  methods: {
    handleShowDetail(item) {
      this.selectedReport = { ...item };
      this.$nextTick(() => {
        const detail = document.querySelector('.detail-card');
        if (detail) {
          detail.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    closeDetail() {
      this.selectedReport = null;
    },
    refreshTables() {
      this.selectedReport = null;
      if (this.$refs.historyTable) {
        this.$refs.historyTable.loadHistory();
      }
    },
  },
};
</script>

<style scoped>
.my-reports-page {
  width: 100%;
  padding-bottom: 30px;
}

.dashboard-sticky-area {
  margin-bottom: 20px;
}

.dashboard-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 100%);
  color: #ffffff;
  padding: 18px 24px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.2);
}

.dashboard-page-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #ffffff;
}

.dashboard-title-icon {
  width: 24px;
  height: 24px;
}

.details-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
}
</style>
